import { Stack, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

type Props = {
    title: string;
};

export function GaiaMapLegendSection({ title, children }: PropsWithChildren<Props>) {
    return (
        <Stack spacing={1}>
            <Typography variant="overline" sx={{ lineHeight: "normal" }}>
                {title}
            </Typography>
            {children}
        </Stack>
    );
}
